
<template>
  <base-modal
    :title="title"
    :width="width"
    :height="height"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-checkbox-group :options="plainOptions" v-model="groupSelected" @change="onChange" />
          <span v-if="plainOptions.length===0">暂无可选分组</span>
        </a-form-item>
        <a-form-item style="text-align:center">
          <a-button type="primary" html-type="submit" style="margin-right:10px;">保存</a-button>
          <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { getGroupChooseList, insertRoleGroup } from '@/api/roleList'

export default {
  name: 'EditGroup',
  mounted () {},
  components: {
    baseModal
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    }
  },
  data () {
    return {
      title: '添加分组',
      width: 600,
      height: 900,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'group' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      plainOptions: [
        { label: 'Apple', value: 'Apple' },
        { label: 'Pear', value: 'Pear' },
        { label: 'Orange', value: 'Orange' }
      ],
      groupSelected: []
    }
  },
  methods: {
    open (flag) {
      this.formClear()
      this.title = `【${this.roleName}】添加分组`
      this.inUserData()
      this.visible = flag
    },
    inUserData () {
      const params = {
        roleId: this.roleId
      }
      getGroupChooseList(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.plainOptions = res.data.map(item => {
              return {
                label: item.name,
                value: item.id
              }
            })
          } else {
            this.plainOptions = []
          }
        }
      })
    },
    // 分组选择变动
    onChange (checkedValues) {},
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          if (this.groupSelected.length === 0) {
            this.$message.error('请先选择要添加的分组！')
            return
          }
          const params = {
            roleId: this.roleId,
            groupIds: this.groupSelected.toString()
          }
          insertRoleGroup(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 清空表单
    formClear () {
      this.groupSelected = []
    },
    cancel () {
      this.open(false)
      this.formClear()
      // this.selectedRowKeys = []
      // this.mList = []
    }
  }
}
</script>

<style scoped>
</style>
